export const ChatConstants = {
  Chat: "Chat",
  EditName: "EditName",
  Apps: "Apps",
  File: "File",
  Location: "Location",
  Favorite: "Favorite",
  Call: "Call",
  VideoCall: "VideoCall",
  InviteChat: "inviteChat",
};

export const messageTypes = {
  Text: "text",
  Link: "link",
  Image: "image",
  Audio: "audio",
  Video: "video",
  Sound: "chat_sound",
  Sticker: "sticker",
  CenterFlie: "center_file",
  Reply: "reply",
  CheckIn: "check_in",
  JoinGroup: "join_group",
  LeaveGroup: "leave_group",
  KickGroup: "kick_group",
  Invited: "invited_group",
  MeetingRecord: "meeting_record",
  MissedCall: "missed call",
  CallEnded: "call ended",
  CallFail: "call fail",
};

export const width = 280;
